<template>
  <b-modal id="order-cancel-modal" centered hide-header hide-footer ok-disabled cancel-disabled>
    <div class="content-subject">
      {{ $t('order.orderCancelConfirmation') }}
    </div>
    <div>
      <b-row class="buttons">
        <b-col>
          <div class="buttons-button">
            <b-button block class="buttons-button-no" @click="$bvModal.hide('order-cancel-modal')">
              {{ $t('common.no') }}
            </b-button>
          </div>
        </b-col>
        <b-col>
          <div class="buttons-button">
            <b-button block class="buttons-button-yes" @click="cancel(id)">
              {{ $t('common.yes') }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: 'OrderCancelModal',
  props: {
    id: String,
  },
  methods: {
    cancel(id) {
      this.$bvModal.hide('order-cancel-modal')
      this.$emit('cancelButtonClicked', id)
    },
  },
}
</script>
<style lang="scss" scoped>
.content-subject {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  @media screen and (max-width: 375px) {
    font-size: 0.95rem;
  }
}
.buttons {
  padding: 10px 0;
  margin: 10px 0 0;
  width: 100%;
  height: 38px;
  line-height: 38px;
  border-radius: 5px;
  font-size: 1rem;
  padding: 0px 0 45px 0px;
  // for iphone5/SE
  @media screen and (max-width: 375px) {
    font-size: 0.85rem;
  }
  &-button {
    &-yes {
      border-color: #fff;
      border-radius: 5px;
      color: white;
      background-color: #d21b24;
      border-bottom: 2px solid #96131a;
      font-weight: bold;
    }
    &-no {
      border-color: #fff;
      border-radius: 5px;
      color: white;
      background-color: #666;
      border-bottom: 2px solid #333;
      font-weight: bold;
    }
  }
}
</style>
